import React from "react";
import HexDropDown from "../HexDropDown";

import "./styles.css";
import HexButton from "../../ui-kit/HexButtons";

const HexFilters = ({
  Filters,
  dropdownPlacement = "",
  componentProps,
  btnClassName = "",
  dropdownClass,
}) => {
  return (
    <HexDropDown
      dropdownComponent={
        <HexButton
          size="md"
          type="filter"
          htmlType="submit"
          className={`full-width ${btnClassName} button-box-shadow`}
          label="Filters"
          icon={<img src="/assets/icons/filter.svg" alt="filters" />}
        />
      }
      clickTrigger
      placement={dropdownPlacement}
      MenuComponent={({ onSave, onReset }) => (
        <div className="hex-filters-dropdown-container">
          <Filters onSave={onSave} onReset={onReset} />
        </div>
      )}
      componentProps={componentProps}
      dropdownClass={dropdownClass}
    />
  );
};

export default HexFilters;
